/*
 * MDB shim for Fa
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Custom/pageHeader.jsx
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Activities/activities-edit.jsx
 * - src/Seating/Filters/UserFilters.jsx
 * - src/Seating/Orders/orderList.jsx
 * - src/Seating/Orders/salesPipelineView.jsx
 * - src/Seating/Patient/PatientViewComponents/createNoteModal.jsx
 * - src/Seating/Patient/PatientViewComponents/liaisonModal.jsx
 * - src/Seating/Patient/PatientViewComponents/typeStatusContainer.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Settings/manualDocumentBuilder.jsx
 */

export default function Fa({ icon, className = "", ...rest }) {
  const iconClassName = icon ? `fa fa-${icon}` : "fa";

  return <i className={`${iconClassName} ${className}`.trim()} {...rest} />;
}
